/*eslint no-var: 0 */
/*eslint camelcase: 0 */
/*eslint @typescript-eslint/consistent-type-assertions: 0 */

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { APP_BASE_HREF } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { RequestComponent } from './pages/request/request.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TextinputComponent } from './components/textinput/textinput.component';
import { DateinputComponent } from './components/dateinput/dateinput.component';
import { SelectInputComponent } from './components/selectinput/selectinput.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { DoneComponent } from './pages/done/done.component';
import { SafePipe } from './pipes/safePipe.pipe';

export function getBaseHref(): string {
  return '/' + (window.location.pathname.split('/')[1] || '');
}

export function httpTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, getBaseHref() + '/clientApp/dist/client-app/assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    RequestComponent,
    TextinputComponent,
    DateinputComponent,
    SelectInputComponent,
    SafePipe,
    CheckboxComponent,
    DoneComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: getBaseHref()
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

declare var __webpack_public_path__: any;
__webpack_public_path__ = (<any>window).DeployUrlFromMyProduct;
